import React, { useState } from 'react'
import PropTypes from 'prop-types'
import TextField from '@mui/material/TextField'

const LookupByIdForm = ({ onLoadHero }) => {
    const [heroId, setHeroId] = useState('')
    const [isLoaded, setIsLoaded] = useState(false)

    // update the stored value when value in the form value changes
    const handleHeroIdChange = ({ target }) => setHeroId(target.value)

    // Loads the selected hero when the enter key is pressed inside the HeroId text box
    const handleKeyPress = event => {
        if (event.key === 'Enter') {
            loadHero()
        } else if (isLoaded) {
            setIsLoaded(false)
        }
    }

    // Call the load hero function with the specified values
    const loadHero = () => {
        // Load the heroes for this id, if not already loaded
        if (!isLoaded) {
            onLoadHero({ heroId })
            setIsLoaded(true)
        }
    }

    return (
        <div className="manual-selecter">
            <TextField
                autoFocus
                id="heroId"
                label="Hero Id"
                margin="dense"
                onBlur={loadHero}
                onChange={handleHeroIdChange}
                onKeyPress={handleKeyPress}
                value={heroId}
                variant="filled"
            />
        </div>
    )
}

LookupByIdForm.propTypes = {
    onLoadHero: PropTypes.func,
}

LookupByIdForm.defaultProps = {
    onLoadHero: () => {},
}

export default LookupByIdForm
